// =============================================
// FILE: src/views/UserDownloadsPage.jsx
// =============================================
import React, { useEffect, useState } from 'react';
import { Card, List, Button, Typography, Empty, Spin, message, Space } from 'antd';
import { CloudDownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import { DownloadsAPI } from '../api/downloads';
import UserMenu from '../components/UserMenu'; // o tu menú habitual del usuario

const { Title, Text } = Typography;

export default function UserDownloadsPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const data = await DownloadsAPI.listForUser();
      setList(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
      message.error('No se pudieron cargar tus descargas');
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const fmtSize = (bytes) =>
    typeof bytes === 'number' ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : '—';

  const fmtDate = (iso) => {
    try {
      return new Date(iso).toLocaleString('es-ES');
    } catch {
      return '—';
    }
  };

  return (
    <>
      {typeof UserMenu === 'function' ? <UserMenu /> : null}

      <div style={{ padding: '80px 20px 20px' }}>
        <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
          <Title level={3} style={{ color: '#fff', margin: 0 }}>Mis descargas</Title>
          <Button onClick={load} icon={<ReloadOutlined />} disabled={loading}>
            Recargar
          </Button>
        </Space>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin tip="Cargando tus descargas..." />
          </div>
        ) : list.length === 0 ? (
          <Empty description="No tienes descargas disponibles" style={{ marginTop: 40 }} />
        ) : (
          <Card>
            <List
              itemLayout="horizontal"
              dataSource={list}
              rowKey={(item) => item.id}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button
                      key="dl"
                      type="link"
                      icon={<CloudDownloadOutlined />}
                      href={`/api/downloads/${item.id}/file`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Descargar
                    </Button>,
                  ]}
                >
                  <List.Item.Meta
                    title={<Text strong>{item.title}</Text>}
                    description={`${fmtSize(item.size_bytes)} · ${fmtDate(item.created_at)}`}
                  />
                </List.Item>
              )}
              pagination={{ pageSize: 10, size: 'small' }}
            />
          </Card>
        )}
      </div>
    </>
  );
}
